// @flow
import axios from 'lib/defaultClient';
import queryString from 'query-string';

export type WriteEventPayload = {
  title: string,
  body: string,
  is_temp: boolean,
  tags: Array<string>,
  categories: Array<string>,
  thumbnail: ?string,
  url_slug?: ?string,
  is_private: boolean,
  series_id: ?string,
};

export const writeEvent = (payload: WriteEventPayload) => axios.post('/events', payload);

export type UpdateEventPayload = {
  id: string,
  title: string,
  body: string,
  tags: Array<string>,
  categories: Array<string>,
  url_slug?: ?string,
  thumbnail?: string,
  is_temp: boolean,
  is_private: boolean,
  series_id: ?string,
};

export const updateEvent = ({ id, ...payload }: UpdateEventPayload) =>
  axios.patch(`/events/${id}`, payload);

export type ReadEventPayload = {
  username: string,
  urlSlug: string,
};

export const readEvent = ({ username, urlSlug }: ReadEventPayload) =>
  axios.get(`/events/@${username}/${urlSlug}`);

export type UploadImagePayload = {
  file: any,
  eventId: string,
  onUploadProgress(): void,
};

export const uploadImage = ({ file, eventId, onUploadProgress }: UploadImagePayload) => {
  const data = new FormData();
  data.append('event_id', eventId);
  data.append('image', file);
  return axios.post('/files/upload/event', data, {
    onUploadProgress,
  });
};

export type TempSavePayload = {
  title: string,
  body: string,
  eventId: string,
};

export const tempSave = ({ eventId, title, body }: TempSavePayload) =>
  axios.post(`/events/${eventId}/saves`, { title, body });

export type CreateUploadUrlPayload = { eventId: string, filename: string };
export const createUploadUrl = ({ eventId, filename }: CreateUploadUrlPayload) => {
  return axios.post('/files/create-url/event-image', { event_id: eventId, filename });
};

/* LISTING RELATED... */
export const getPublicEvents = (cursor: ?string, category: ?string, sort: ?string) => {
  return axios.get('/events/public', {
    params: {
      cursor,
      category,
      sort,
    },
  });
};

export const getTrendingEvents = (offset: ?number) => {
  const query = offset ? `?offset=${offset}` : '';
  return axios.get(`/events/trending${query}`);
};

export type GetUserEventsPayload = {
  username: string,
  tag?: string,
  cursor?: string,
};

export const getUserEvents = ({ username, cursor, tag }: GetUserEventsPayload) => {
  const query = queryString.stringify({
    cursor,
    tag,
  });
  return axios.get(`/events/@${username}?${query}`);
};

export type GetPublicEventsByCategoryPayload = {
  category: string,
  cursor?: string,
  sort?: string,
};

export const getPublicEventsByCategory = (payload: GetPublicEventsByCategoryPayload) => {
  const query = queryString.stringify(payload);
  return axios.get(`/events/public?${query}`);
};

export type GetPublicEventsByTagPayload = {
  tag: string,
  cursor?: string,
};

export const getPublicEventsByTag = (payload: GetPublicEventsByTagPayload) => {
  const query = queryString.stringify(payload);
  return axios.get(`/events/public?${query}`);
};

export type GetTempEventsPayload = {
  username: string,
  cursor?: string,
};

export const getTempEvents = ({ username, cursor }: GetTempEventsPayload) => {
  const query = queryString.stringify({
    is_temp: true,
    cursor,
  });
  return axios.get(`/events/@${username}?${query}`);
};

export const deleteEvent = (eventId: string) => {
  return axios.delete(`/events/${eventId}`);
};

export const getEventById = (eventId: string) => {
  return axios.get(`/events/${eventId}`);
};

export const getEventSequences = (eventId: string) => {
  return axios.get(`/events/sequences?event_id=${eventId}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/events/index.js